export default __webpack_public_path__ + "static/Siam Validus_logo-36c92b697d49536f609e9766875aaf79.png";